import moment from 'moment';

export function getHumanizedTime(utcDateTimeString, format) {
  try {
    const utcMoment = moment.utc(utcDateTimeString);
    const localMoment = utcMoment.local();

    if (format !== undefined) {
      return localMoment.format(format);
    }

    const now = moment();
    const diffInSeconds = now.diff(localMoment, 'seconds');

    if (diffInSeconds < 0) return 'in the future';
    if (diffInSeconds < 30) return 'just now';
    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return diffInMinutes === 1
        ? '1 minute ago'
        : `${diffInMinutes} minutes ago`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return diffInHours === 1
        ? '1 hour ago'
        : `${diffInHours} hours ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
      return diffInDays === 1
        ? '1 day ago'
        : `${diffInDays} days ago`;
    }

    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) {
      return diffInWeeks === 1
        ? '1 week ago'
        : `${diffInWeeks} weeks ago`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return diffInMonths === 1
        ? '1 month ago'
        : `${diffInMonths} months ago`;
    }

    const diffInYears = Math.floor(diffInDays / 365);
    return diffInYears === 1
      ? '1 year ago'
      : `${diffInYears} years ago`;
  } catch (error) {
    return 'Invalid date';
  }
}
